import { createAction, props } from '@ngrx/store';
import { EMessageActions, IMessage, IMessageItem } from '../models/message.model';

export const loadMessages = createAction(EMessageActions.LOAD_MESSAGES_LIST);

export const loadMessagesSuccess = createAction(
  EMessageActions.LOAD_MESSAGES_LIST_SUCCESS,
  props<{ messages: IMessageItem[]; has_extra_row?: boolean }>(),
);

export const setMessagesList = createAction(
  EMessageActions.SET_MESSAGES_LIST,
  props<{ list: number[] }>(),
);

export const loadMessagesError = createAction(
  EMessageActions.LOAD_MESSAGES_LIST_ERROR,
  props<{ error: any }>(),
);

export const viewMessage = createAction(
  EMessageActions.VIEW_MESSAGE,
  props<{
    id_message: number;
    lock?: boolean;
    unlock?: boolean;
    page?: number
  }>(),
);
export const clearMessages = createAction(
  EMessageActions.CLEAR_MESSAGE,
);

export const viewMessageSuccess = createAction(
  EMessageActions.VIEW_MESSAGE_SUCCESS,
  props<{ messages: IMessage[]; extraData: any, currentPage: number, hasMoreData: boolean }>(),
);

export const viewMessageError = createAction(
  EMessageActions.VIEW_MESSAGE_ERROR,
  props<{ error: any }>(),
);

export const setSpam = createAction(
  EMessageActions.SET_SPAM,
  props<{ id: number; spam: boolean }>(),
);

export const setSpamSuccess = createAction(
  EMessageActions.SET_SPAM_SUCCESS,
  props<{ messages: IMessage[] }>(),
);

export const setSpamError = createAction(
  EMessageActions.SET_SPAM_ERROR,
  props<{ error: any }>(),
);

export const deleteSpam = createAction(EMessageActions.DELETE_SPAM);

export const deleteSpamSuccess = createAction(
  EMessageActions.DELETE_SPAM_SUCCESS,
  props<{ messages: IMessage[] }>(),
);

export const deleteSpamError = createAction(
  EMessageActions.DELETE_SPAM_ERROR,
  props<{ error: any }>(),
);
